import {Component, effect, Input, OnInit, Signal, ViewEncapsulation} from '@angular/core';
import {ActivatedRoute, NavigationEnd, Params, Router, Routes} from '@angular/router';
import {AclService, UserAuthenticationService} from '@galec/services';
import {PointVente} from "@models/pointVente.model";
import * as _ from 'lodash';
import {routes} from '@galec/modules/back/back-routing.module';
import {PointVenteRepository} from "@galec/repositories";
import {User} from "@models/user.model";
import {CentraleRepository} from "@galec/repositories/centrale.gql";
import {LangService} from "@galec/services/global/lang.service";
import {InfosReglementairesPariteRepository} from "@galec/repositories/infosReglementairesParite.gql";
import {InformationsReglementairesParite} from "@models/informationsReglementairesParite.model";
import {ClientMasterService} from "@galec/services/global/clientMaster.service";

@Component({
    selector: 'galec-back-container',
    templateUrl: './back-container.component.html',
    styleUrls: ['./back-container.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class BackContainerComponent implements OnInit {
    @Input() showTitle = true;

    private _master: Signal<PointVente> = this.clientMasterService._currentMaster;
    public master: PointVente;
    public masters: PointVente[] = [];

    public showMastersList: boolean = false;

    routes: Routes;
    init = true;
    burgerMenuOpen = false;
    delegation: any = null;
    showProfileBtn = false;
    user: User;
    role: any;
    isRouteAdmin = false;
    loading = true;
    name = '';
    isUserCentral = false;

    public showTradMenu: boolean;

    hideParityNotification = true;

    public currentLang: string;

    constructor(
        private router: Router,
        public userAuthenticationService: UserAuthenticationService,
        private aclService: AclService,
        private centraleRepository: CentraleRepository,
        private langService: LangService,
        private infosReglementairePariteRepository: InfosReglementairesPariteRepository,
        private readonly clientMasterService: ClientMasterService,
    ) {
        effect((): void => {
            const master: PointVente = this._master();
            if (master !== undefined) {
                this.master = master;
                this.checkDateUpdateParityInfo(master);
                this.masters = this.clientMasterService.getMasters();
                this.delegation = master;
            }

            const showMastersList: boolean = this.clientMasterService.getShowMastersList();
            if (showMastersList !== this.showMastersList) {
                this.showMastersList = showMastersList;
            }

            this.currentLang = this.langService.getCurrentLang();
            this.translateNavBar();
        });
    }

    ngOnInit(): void {
        this.clientMasterService.loadMasters();
        this.currentLang = this.langService.getCurrentLang();

        this.userAuthenticationService.currentUser.subscribe(user => {
            this.routes = _.filter(routes, el => el?.data?.in_sidebar) as Routes;
            this.routes = _.filter(this.routes, el => this.aclService.can(el.data.name)) as Routes;
            this.routes = _.filter(this.routes, el => {
                return el.data.requirePointVente ? user.codePanonceau?.length > 0 : true;
            }) as Routes;
            this.routes = _.orderBy(this.routes, ['data.priority'], 'desc') as Routes;
            this.translateNavBar();

            this.user = user;
            this.isUserCentral = user.connectedAs === 'central';
            this.getDelegation();
            this.router.events.subscribe(e => {
                if (e instanceof NavigationEnd) {
                    this.getDelegation(e);
                }
            });
            this.showTradMenu = (['central', 'magasin'].includes(user.role));
            // Get centrale name.
            if (user.role === 'central') {
                this.centraleRepository.select({code_panonceau_centrale: this.user.codePanonceauCentral})
                    .subscribe(centrale => this.name = centrale.nom);
            }
        });
    }

    checkDateUpdateParityInfo(pointVente: PointVente): void {
        let infoPariteMagasinActuel: InformationsReglementairesParite = null;
        this.infosReglementairePariteRepository.selectInfosReglementairesPariteById(pointVente.id_base_adherent).subscribe({
            next: (infosParite): void => {
                infoPariteMagasinActuel = infosParite.data.informations_reglementaires_parite[0];
                const dateLastUpdate: Date = new Date(infoPariteMagasinActuel.updated_at);
                const dateActuelle = new Date();
                const dateButoirProchaineMaj = new Date((this.fonctionTestDate(dateActuelle) ? dateActuelle.getFullYear() : dateActuelle.getFullYear() + 1), 2, 1);
                const ancienneDateButoir = new Date(dateButoirProchaineMaj.getFullYear() - 1, dateButoirProchaineMaj.getMonth(), dateButoirProchaineMaj.getDate());

                // si la date butoir n'est pas dépassée
                // vérifier s'il n'y a pas eu une maj depuis la date butoir précédente
                if (dateLastUpdate.getTime() < ancienneDateButoir.getTime()){
                    this.hideParityNotification = false;
                } else {
                    this.hideParityNotification = true;
                }
            }, error: (error): void => {
                console.error(error);
            }
        });
    }

    fonctionTestDate(date: Date): boolean {
        return (date.getMonth() < 2 || (date.getMonth() === 2 && date.getDate() === 1));
    }

    getDelegation(e: NavigationEnd = null) {
        // Check if route.
        this.isRouteAdmin = this.router.url.includes('admin');
        // Show back to profile button.
        this.showProfileBtn = ![`/${this.currentLang}/app/admin/national`, `/${this.currentLang}/app/admin/centrale`].includes(e?.urlAfterRedirects ?? this.router.url)
            || this.user.connectedAs !== this.user.role;
        // If route is not admin & is in delegation.
        this.role = this.getDelegatedRole(e?.urlAfterRedirects) ? 'national' : this.user.connectedAs;
        this.delegation = null;
        if (!this.isRouteAdmin && this.user.role !== 'magasin' && this.user.codePanonceau) {
            if (this.master) {
                this.delegation = this.master;
            }
        } else if (this.user.role !== this.user.connectedAs && !this.router.url.includes('nationale')) {
            this.centraleRepository.select({code_panonceau_centrale: this.user.codePanonceauCentral}).subscribe({
                next: (centrale): void => {
                    this.delegation = centrale;
                }, error: (error) => {
                    console.error(error);
                }
            });
        }
        this.loading = false;
    }

    private getDelegatedRole(url: string = this.router.url): boolean {
        // Show header back profile name.
        const urlWithoutParams = url.split('?')[0];
        return (url.includes('national') || urlWithoutParams === `/${this.currentLang}/app/admin/centrale`) && this.user.connectedAs !== this.user.role;
    }

    goBackAdmin(): void {
        this.clientMasterService.setMastersListVisible(false);
        this.clientMasterService.clear();
        this.getDelegatedRole();
        let toEdit: any = {codePanonceau: null};
        if (this.getDelegatedRole()) {
            toEdit = {...toEdit, codePanonceauCentral: null, connectedAs: this.user.role};
        }
        this.userAuthenticationService.editUserInfo(toEdit);
        this.langService.navigate(this.role === 'centrale' ? "/app/admin/centrale" : "/app/admin");
    }

    /**
     * Logout callback function.
     */
    logout() {
        this.userAuthenticationService?.logout().then();
    }

    public get User() {
        return this.userAuthenticationService.currentUserValue;
    }

    public get checkIsAdmin(): boolean {
        return this.User?.codePanonceau?.length > 0 && !this.router.url.includes('admin');
    }

    click(url: string) {
        this.burgerMenuOpen = false;
        // this.router.navigate([url]);
    }

    private translateNavBar(): void {
        for (const route of this.routes) {
            switch (route.path) {
                case "home":
                case "admin":
                    route.data.title = this.langService.getTranslateInstant('CATEGORIES.NAVBAR.ACCUEIL');
                    break;
                case "info-general":
                    route.data.title = this.langService.getTranslateInstant('CATEGORIES.NAVBAR.INFOS_GENERALES');
                    break;
                case "actualites":
                    route.data.title = this.langService.getTranslateInstant('CATEGORIES.NAVBAR.ACTUS');
                    break;
                case "ouvertures-fermetures":
                    route.data.title = this.langService.getTranslateInstant('CATEGORIES.NAVBAR.OUV_FERM');
                    break;
                case "services":
                    route.data.title = this.langService.getTranslateInstant('CATEGORIES.NAVBAR.SERVICES');
                    break;
                case "infos-reglementaires":
                    route.data.title  = this.langService.getTranslateInstant('CATEGORIES.NAVBAR.INFOS_REGLEMENTAIRES');
                    break;
                case "aides":
                    route.data.title = this.langService.getTranslateInstant('CATEGORIES.NAVBAR.AIDES');
                    break;
                default:
                    console.error(`Element de la navbar inconnu : ${route.path}`);
                    break;
            }
        }
    }

    public changeCurrentMaster(codeActivite: string, numeroOrdre: number): void {
        this.clientMasterService.setCurrentIdMasterClient({codeActivite, numeroOrdre});
    }
}
